import { React, useState } from 'react';
import { observer } from "mobx-react-lite"

import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';

import TextField from '@mui/material/TextField';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Link from '@mui/material/Link';
import Paper from '@mui/material/Paper';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import Typography from '@mui/material/Typography';
import { createTheme, ThemeProvider } from '@mui/material/styles';

import CopyRight from 'pages/common/CopyRight';
import { useAuthStore } from 'store/RootProvider'
import FormConst from 'constants/FormConst'


const theme = createTheme();

/*
 * Module - SignIn.js
 *
 * Description : 로그인 화면 
 *
 * 작성자 : Choi young ho. 
 * Created on Mon Jun 20 2022
 * Copyright (c) 2022 Renewhouse corp
 */

const SignIn = observer(() => {

	const authStore = useAuthStore();
	const [msg, setMsg] = useState('');
	const [msgVisible, setMsgVisible] = useState(false);

	const [loginId, setLoginId] = useState('');
	const [pwStr, setPwStr] = useState('');

	const doStore = async (event) => {
		event.preventDefault();
		try {
			setMsg('');
			setMsgVisible(false);

			const data = new FormData(event.currentTarget);

			let param = {};
			param.ezCompanyId = loginId;
			param.loginMode = 'true';
			param.userPw = pwStr;

			let result = await authStore.reqLogin(param);
			if (result[FormConst.ERROR_MSG] !== '') {
				console.log("Error", result[FormConst.ERROR_MSG]);
				setMsg(result[FormConst.ERROR_MSG]);
				setMsgVisible(true);
				// setLoading(false);
				return;
			}

		}
		catch (e) {
			console.log(e);
		}
	};

	return (
		<ThemeProvider theme={theme}>
			<Grid container component="main" sx={{ height: '100vh' }}>
				<Grid item
					xs={false}
					sm={4}
					md={7}
					sx={{
						backgroundImage: 'url(https://source.unsplash.com/random)',
						backgroundRepeat: 'no-repeat',
						backgroundColor: (t) =>
							t.palette.mode === 'light' ? t.palette.grey[50] : t.palette.grey[900],
						backgroundSize: 'cover',
						backgroundPosition: 'center',
					}}
				/>
				<Grid item
					xs={12} sm={8} md={5} component={Paper} elevation={6} square>
					<Box
						sx={{
							my: 8,
							mx: 4,
							display: 'flex',
							flexDirection: 'column',
							alignItems: 'center',
						}}
					>
						<Avatar sx={{ m: 1, bgcolor: 'secondary.main' }}>
							<LockOutlinedIcon />
						</Avatar>
						<Typography component="h1" variant="h5">
							Sign in
						</Typography>


						<Box component="form" noValidate onSubmit={doStore} sx={{ mt: 1 }}>
							<TextField
								margin="normal"
								required
								fullWidth
								id="email"
								label="Email Address"
								name="email"
								autoComplete="email"
								autoFocus
								value={loginId}
								onChange={(event) => {
									setLoginId(event.target.value);
								}}
							/>
							<TextField
								margin="normal"
								required
								fullWidth
								name="password"
								label="Password"
								type="password"
								id="password"
								autoComplete="current-password"
								value={pwStr}
								onChange={(event) => {
									setPwStr(event.target.value);
								}}
							/>
							{(msgVisible) && (
								<Typography component="h1" variant="h6" color={'red'}>
									{msg}
								</Typography>
							)}
							<FormControlLabel
								control={<Checkbox value="remember" color="primary" />}
								label="Remember me"
							/>
							<Button
								type="submit"
								fullWidth
								variant="contained"
								sx={{ mt: 3, mb: 2 }}
							>
								Sign In
							</Button>
							<Grid container>
								<Grid item xs>
									<Link href="#" variant="body2">
										Forgot password?
									</Link>
								</Grid>
								<Grid item>
									<Link href="#" variant="body2">
										{"Don't have an account? Sign Up"}
									</Link>
								</Grid>
							</Grid>
							<CopyRight sx={{ mt: 5 }} />
						</Box>
					</Box>
				</Grid>
			</Grid>
		</ThemeProvider>
	);
});

export default SignIn;